import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import "@/index.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import CRM from "@/pages/CRM";
import Tenders from "@/pages/Tenders";
import CompanyProfile from "@/pages/CompanyProfile";
import AISearch from "@/pages/AISearch";
import MapView from "@/pages/MapView";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DashboardLayout from "@/components/layout/DashboardLayout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-cyan-400">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <DashboardLayout>{children}</DashboardLayout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/inscription" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/opportunites" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
      <Route path="/opportunites/:id" element={<ProtectedRoute><OpportunityDetail /></ProtectedRoute>} />
      <Route path="/carte" element={<ProtectedRoute><MapView /></ProtectedRoute>} />
      <Route path="/recherche-ia" element={<ProtectedRoute><AISearch /></ProtectedRoute>} />
      <Route path="/crm" element={<ProtectedRoute><CRM /></ProtectedRoute>} />
      <Route path="/appels-offres" element={<ProtectedRoute><Tenders /></ProtectedRoute>} />
      <Route path="/entreprise" element={<ProtectedRoute><CompanyProfile /></ProtectedRoute>} />
      <Route path="/tarifs" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/paiement/succes" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/paiement/annule" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
